/* eslint-disable import/prefer-default-export */
export const TRAINING_NAME = {
  TERMS_AND_CONDITIONS: 'termsAndConditions',
  EMPLOYEE_FIRST_LOGIN: 'employeeFirstLogin',
  ENTERPRISE_FIRST_LOGIN: 'enterpriseFirstLogin',
  ENTERPRISE_AUTOMATED_ATTENDANCE: 'automatedAttendance',
};
